export const GET_PRIMARY_URL = 'p/auth/v1/webapp/verify';
